// NotFoundPage: the 404, inside the app's frame (header and all). Two
// shapes: a path that is no page, and a token address the API does not know
// (PairPage hands that over on `invalid_pool_addr` / `pair_not_found`). One
// empty card in the page's place, as Discover's empty Watchlist draws it: a
// title, one quiet line, one way on.

import { CompassIcon } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'
import { Tile } from '../components/ui/Tile'
import soft from '../styles/soft.module.css'
import styles from './NotFoundPage.module.css'

export type NotFoundKind = 'page' | 'token'

const COPY: Record<NotFoundKind, { title: string; note: string }> = {
  page: { title: 'Page not found', note: 'There is no page at this address.' },
  token: { title: 'Token not found', note: 'We have no trades for this address.' },
}

export function NotFoundPage({ kind = 'page' }: { kind?: NotFoundKind }) {
  const navigate = useNavigate()
  const copy = COPY[kind]
  return (
    <div className={styles.page} data-surface="soft">
      <section className={styles.card} aria-label={copy.title} data-not-found={kind}>
        <Tile tone="graphite" large>
          <CompassIcon size={26} weight="fill" />
        </Tile>
        <h1 className={styles.title}>{copy.title}</h1>
        <p className={styles.note}>{copy.note}</p>
        <button type="button" className={soft.btn} onClick={() => navigate('/discover')}>
          Go to Discover
        </button>
      </section>
    </div>
  )
}
